import { render, staticRenderFns } from "./MasterNotePhraseDialog.vue?vue&type=template&id=7d349b20&scoped=true&"
import script from "./MasterNotePhraseDialog.vue?vue&type=script&lang=js&"
export * from "./MasterNotePhraseDialog.vue?vue&type=script&lang=js&"
import style0 from "./MasterNotePhraseDialog.vue?vue&type=style&index=0&id=7d349b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d349b20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
